const getMaskedCurrency = (currency: string): string => {
  if (currency === 'USD') return 'USDC';
  if (currency === 'EUR') return 'EURC';

  return currency;
};

export default getMaskedCurrency;
